import { isEmpty } from 'lodash';
import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import AchievementRank from 'Component/achievement-rank';
import formatCurrency from 'Helper/formatCurrency';
import { useUserInfo } from 'Store/userInfo';
import { TextBold, TextRegular } from 'UiKit/typography';
import { COLOR_CONFIG } from 'View/host-achievement-detail/component/user-rank-card/const';

import styles from './styles.module.css';
import formatNumber from 'Helper/formatNumber';

const UserRankCard = ({ data }) => {
  const { t } = useTranslation('host-achievement');
  const isDataAvaialble = !isEmpty(data);
  const colors = isDataAvaialble ? COLOR_CONFIG[data?.rank] || COLOR_CONFIG.default : COLOR_CONFIG.empty;
  const displayValue = isDataAvaialble
    ? data?.isCurrency
      ? formatCurrency(data?.avgValue)
      : `${formatNumber(data?.avgValue)}%`
    : t('page.rank_not_available');

  const { name } = useUserInfo();

  return (
    <Box className={styles['user-rank__container']} background={colors.card}>
      <Box className={styles['user-rank__ribbon']} background={colors.ribbon}>
        <TextRegular color="var(--color-semantic-white)" fontSize="var(--font-caption2)">
          {t('page.ranking')}
        </TextRegular>
      </Box>
      <AchievementRank rankPosition={data?.rank} size="sm" />
      <Flex flexDirection="column">
        <TextBold>{name}</TextBold>
        <TextRegular fontSize="var(--font-caption1)">{displayValue}</TextRegular>
      </Flex>
    </Box>
  );
};

export default UserRankCard;
